module.exports = __webpack_public_path__ + "static/media/a-editora-img-circulos.c5700b90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/a-editora-img-circulos.png
// module id = 214
// module chunks = 0